import { render, staticRenderFns } from "./ShippingPartner.vue?vue&type=template&id=564dc435&scoped=true"
import script from "./ShippingPartner.vue?vue&type=script&lang=js"
export * from "./ShippingPartner.vue?vue&type=script&lang=js"
import style0 from "./ShippingPartner.vue?vue&type=style&index=0&id=564dc435&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "564dc435",
  null
  
)

export default component.exports